import { render, staticRenderFns } from "./cadastrar-propina-preco.vue?vue&type=template&id=242a6a48&scoped=true&"
import script from "./cadastrar-propina-preco.vue?vue&type=script&lang=js&"
export * from "./cadastrar-propina-preco.vue?vue&type=script&lang=js&"
import style0 from "./cadastrar-propina-preco.vue?vue&type=style&index=0&id=242a6a48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a6a48",
  null
  
)

export default component.exports